import { Component, OnInit } from '@angular/core';
import { NavController, ActionSheetController, Events } from 'ionic-angular';
import { ResumeService } from '../../../../../../../UI/src/app/shared/resume/resume.service';
import { EditViewPageComponent } from '../edit-view/edit-view.component';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '../../../../../../../UI/src/app/shared/constants';

@Component({
  selector: 'page-res-timeline',
  templateUrl: 'res-timeline.component.html'
})
export class ResTimelinePageComponent implements OnInit {
  public data: any;
  public timelineData: any = [];
  public timelineDataOriginal: any;
  public timelineMap = null;
  public previousFilter = null;
  public translations: any;

  constructor(
    public resumeService: ResumeService,
    public actionSheetCtrl: ActionSheetController,
    public events: Events,
    public navCtrl: NavController,
    private translate: TranslateService
  ) {
    this.translate.get(['CAREER_RESUME_YES', 'CAREER_RESUME_NO', 'CAREER_CANCEL', 'CAREER_ADD_LABEL', 'CAREER_RESUME_FILTERBY'])
      .subscribe((obj) => {
        this.translations = obj;
      });
    this.timelineMap = this.resumeService.getTimelineMap();
    this.events.subscribe('refreshEditResumeData', (data) => {
      this.ngOnInit();
    });
    this.events.subscribe('filterResumeTimeLine', (data) => {
      this.filterItemBy(this, data);
    });
  }

  ngOnInit() {
    this.getDataAndConfig();
  }

  addItem() {
    let actionSheet = this.actionSheetCtrl.create({
      buttons: this.getActionItems(this.translations['CAREER_ADD_LABEL'], this.addNewItemBy)
    });
    actionSheet.present();
    // This checkin(https://github.com/ionic-team/ionic/pull/11543/files) is in open state. Once the changes got merged to ionic, 
    // we don't need below logic for accessibility.
    setTimeout(() => {
      let elm = <HTMLDivElement>document.querySelector('div.action-sheet-wrapper');
      elm.setAttribute('tabindex','-1');
      elm.setAttribute('role','dialog');
      elm.focus();
    },300)
  }

  showFilterActions() {
    var buttons = this.getActionItems(this.translations['CAREER_RESUME_FILTERBY'], this.filterItemBy);
    buttons.push({
      text: 'Clear Filter',
      role: 'destructive',
      handler: () => { this.filterItemBy(this, "CLEARALL") }
    });
    let actionSheet = this.actionSheetCtrl.create({
      buttons: buttons
    });
    actionSheet.present();
    // This checkin(https://github.com/ionic-team/ionic/pull/11543/files) is in open state. Once the changes got merged to ionic, 
    // we don't need below logic for accessibility.
    setTimeout(() => {
      let elm = <HTMLDivElement>document.querySelector('div.action-sheet-wrapper');
      elm.setAttribute('tabindex','-1');
      elm.setAttribute('role','dialog');
      elm.focus();
    },300)
  }

  getFileLocation(identifier) {
    return window.localStorage.getItem(Storage.DATASTORE) + 'FileAssets/' + identifier;
  }

  editResumeItem(tlData) {
    this.navCtrl.push(EditViewPageComponent, { config: tlData.config, data: tlData.data });
  }

  getMaxStars(config) {
    return this.resumeService.getMaxStars(config);
  }

  private getRawValue(tlData, field, fieldNm) {
    if (field.baseline || field.displayTypeName == 'starrating' || fieldNm == 'locationPreferences') {
      return tlData.data[fieldNm];
    } else {
      return tlData.data.optional[fieldNm];
    }
  }

  getValue(field, tlData) {
    const fieldNm = field.fieldName[0].toLowerCase() + field.fieldName.substring(1);
    const val = this.getRawValue(tlData, field, fieldNm);
    switch (field.displayTypeName) {
      case "codelookup":
      case "tablelookup":
        const code = field.options.codes.filter(cd => cd.itemCode == val)[0];
        return code ? code.itemText : null;
      case "singlelinetext":
      case "multilinetext":
      case "textentry":
      case "starrating":
      case "number":
        return val;
      case "date":
        return this.getDateStr(val);
      case "checkbox":
        if (fieldNm == 'urlRequired' || fieldNm == 'attachmentRequired') {
          return this.attachments(fieldNm, tlData.data);
        }
        return val == true ? this.translations["CAREER_RESUME_YES"] : this.translations["CAREER_RESUME_NO"];
      default:
        console.log('resume timeline value generation missing for >> ', val);
        return field.displayTypeName;
    }
  }

  private attachments(fieldNm, data) {
    const filterKey = fieldNm == 'urlRequired' ? 'URL' : 'ATTACHMENT';
    return data.attachments.filter(a => a.attachmentType == filterKey);
  }

  private getActionItems(prefix, callBack) {
    var buttons = [];
    //adding all config objects sections in timeline.
    for (var i = 0; i < this.data.sections.length; i++) {
      const tlObj = this.data.sections[i];
      buttons.push({
        text: prefix + ' ' + tlObj.title,
        handler: () => { callBack(this, tlObj) }
      });
    }
    //adding a default cancel button
    buttons.push({
      text: this.translations['CAREER_CANCEL'],
      role: 'cancel'
    });
    return buttons;
  }

  private getDateStr(dtStr) {
    if(dtStr) {
      if (!window.localStorage.getItem(Storage.CULTURE)){
         window.localStorage.setItem(Storage.CULTURE, Storage.ENGLISH_CULTURE);
      }
      const culture = window.localStorage.getItem(Storage.CULTURE);
      return (new Date(dtStr)).toLocaleDateString(culture);
    } else return '';
  }

  private addNewItemBy(ref, tlObj) {
    ref.filterItemBy(ref, tlObj);
    ref.navCtrl.push(EditViewPageComponent, { config: tlObj, data: null });
  }

  private filterItemBy(ref, tlObj) {
    ref.previousFilter = tlObj;
    if (tlObj == "CLEARALL") {
      ref.timelineData = ref.timelineDataOriginal;
    } else {
      ref.timelineData = ref.timelineDataOriginal.filter(a => a.config.fieldGroup == tlObj.fieldGroup)
    }
  }

  private getDataAndConfig() {
    this.data = this.resumeService.getResumeConfig('TIMELINE');
    this.timelineData = [];
    for (var i = 0; i < this.data.sections.length; i++) {
      const tlObj = this.data.sections[i];
      var tempArr = this.resumeService.getResumeValue(this.timelineMap[tlObj.name].dto);
      //if no resume then no data to be displayed.
      if (tempArr == undefined) {
        this.timelineDataOriginal = [];
        return;
      }
      for (var j = 0; j < tempArr.length; j++) {
        this.timelineData.push({
          data: tempArr[j],
          config: tlObj,
          icon: this.timelineMap[tlObj.name].icon
        });
      }
    }
    this.timelineDataOriginal = JSON.parse(JSON.stringify(this.timelineData));
    //load previous filter in case of page refresh to retain the page scrill status but refresh the content;
    if (this.previousFilter) {
      this.filterItemBy(this, this.previousFilter)
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/modules/edit-profile/resume/res-timeline/res-timeline.component.ts